import type { PaginationProps } from 'modules/types'
import CONSTANT from 'modules/constant'
import type { ReferralHistory, ReferralDetail } from 'modules/referral/referral.dto'
import { API, download, headers } from './api'

// Define ReferralOwner interface
interface ReferralOwner {
  id: number
  referrerMemberId: string
  referrerName: string
  referralVin: string
  referralVinStatus: string
  referralName: string
  registrationSubmissionDate: string
  approvedDate?: string
  rejectedDate?: string
}

export const referralApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getReferralHistoryList: builder.mutation<PaginationProps<ReferralHistory>, FormData>({
      query: (formData) => ({
        url: CONSTANT.URL_REFERRAL_HISTORY_LIST,
        method: 'POST',
        headers: headers({ useContentType: false }),
        body: formData
      })
    }),
    getReferralOwnerList: builder.mutation<PaginationProps<ReferralOwner>, FormData>({
      query: (formData) => ({
        url: CONSTANT.URL_REFERRAL_REGISTRATION_LIST,
        method: 'POST',
        headers: headers({ useContentType: false }),
        body: formData
      })
    }),
    getReferralDetail: builder.query<ReferralDetail, number | string>({
      query: (id) => ({
        url: CONSTANT.URL_REFERRAL_DETAIL + id,
        method: 'GET',
        headers: headers()
      })
    }),
    getReferralOwnerDetail: builder.mutation<ReferralOwner, number | string>({
      query: (id) => ({
        url: CONSTANT.URL_REFERRAL_DETAIL + id,
        method: 'GET',
        headers: headers()
      })
    }),
    downloadReferralOwnerList: builder.mutation<PaginationProps<ReferralOwner>, FormData>({
      query: (formData) => ({
        url: CONSTANT.URL_REFERRAL_REGISTRATION_DOWNLOAD,
        method: 'POST',
        headers: headers({ useContentType: false }),
        body: formData,
        responseHandler: download,
        formData: true
      })
    })
  })
})

export const {
  useGetReferralHistoryListMutation,
  useGetReferralOwnerListMutation,
  useGetReferralDetailQuery,
  useGetReferralOwnerDetailMutation,
  useDownloadReferralOwnerListMutation
} = referralApi

export type { ReferralOwner }
